'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { Align, Chips, ChipsList, Column, Columns, Text, TextLevels, TypographyBold } from '@bytel/trilogy-react';

import { HomepackProduct } from '@app-types/home-pack';

import { upperCaseAndAddDash } from '../_helpers/utils';

export function ProductsFilter({
    staticsProducts,
    selectedChips,
}: {
    staticsProducts: HomepackProduct[];
    selectedChips: string;
}) {
    return (
        <Columns mobile verticalAlign={Align.CENTER}>
            <Column narrow>
                <Text marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO}>
                    Filtrer:
                </Text>
            </Column>
            <Column>
                <ChipsList multiple>
                    {[...new Set(staticsProducts.map((product) => product.techno))].map((technoName) => (
                        <FiltersContainer key={technoName} technoName={technoName} selectedChips={selectedChips} />
                    ))}
                </ChipsList>
            </Column>
        </Columns>
    );
}

function FiltersContainer({ technoName, selectedChips }: Readonly<{ technoName: string; selectedChips: string }>) {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const isActive = technoName
        ? selectedChips
              ?.split(',')
              .map((techno) => upperCaseAndAddDash(techno))
              ?.includes(upperCaseAndAddDash(technoName))
        : false;

    const handleChipClick = () => {
        const newSearchParams = new URLSearchParams();

        const currentTechnos = (searchParams.get('techno')?.split(',') || [])
            .map((t) => upperCaseAndAddDash(t))
            .filter(Boolean)
            .map((t) => t.trim());

        const formattedTechno = upperCaseAndAddDash(technoName).trim();

        if (currentTechnos.includes(formattedTechno)) {
            const filteredTechnos = currentTechnos.filter((techno) => techno !== formattedTechno);
            if (filteredTechnos.length) {
                const technoString = filteredTechnos.join(',');
                newSearchParams.append('techno', technoString);
            }
        } else {
            const newTechnos = [...currentTechnos, formattedTechno];
            const technoString = newTechnos.join(',');
            newSearchParams.append('techno', technoString);
        }

        const queryString = newSearchParams.toString().replace(/%2C/g, ',');
        const newUrl = queryString ? `${pathname}?${queryString}` : pathname;

        router.push(newUrl, { scroll: false });
    };

    return (
        <Chips id={technoName} onClick={handleChipClick} active={isActive}>
            {technoName}
        </Chips>
    );
}
